import axios from 'axios';
import Vue from 'vue';
import Vuedals from 'vuedals';
import VueCookie from 'vue-cookie';
import duel from 'dueljs';
import { fpjsPlugin } from '@fingerprintjs/fingerprintjs-pro-vue-v2';
import createApp from '../main_ssr';
import createStore from '../store';

axios.interceptors.request.use(
  (config) => {
    /* eslint-disable no-undef */
    if (globalThis?._skConfig?.platform === 'ios'
      || globalThis?._skConfig?.platform === 'android') {
      config.headers.platform = globalThis._skConfig.platform;
    }
    /* eslint-enable no-undef */
    return config;
  },
  (error) => Promise.reject(error),
);

if (process.env.FINGERPRINT_TOKEN) {
  Vue.use(fpjsPlugin, {
    loadOptions: {
      apiKey: process.env.FINGERPRINT_TOKEN,
    },
  });
}
Vue.use(Vuedals);
Vue.use(VueCookie);

const store = createStore();

if (window.__INITIAL_STATE__) {
  store.replaceState(window.__INITIAL_STATE__);
  delete window.__INITIAL_STATE__;
}

const { tabManager } = store.state;
const tabManagerChannel = duel.channel('tab-manager');
tabManager.channel = tabManagerChannel;
tabManager.isActiveTab = tabManagerChannel.currentWindowIsMaster.bind(tabManagerChannel);

tabManager.listenEvent = (name, callback) => {
  if (tabManagerChannel) {
    tabManagerChannel.on(name, callback);
  }
};

tabManager.removeListener = (name) => {
  if (tabManagerChannel) {
    tabManagerChannel.off(name);
  }
};

tabManager.emit = (name, data, activeTabCallback) => {
  if (tabManagerChannel && tabManager.isActiveTab()) {
    const eventCallback = tabManagerChannel._triggers[name];
    if (eventCallback) {
      eventCallback(data);
    }

    if (typeof activeTabCallback === 'function') {
      activeTabCallback();
    }

    tabManagerChannel.broadcast(name, data);
  }
};

tabManager.broadcast = (name, data) => {
  if (tabManagerChannel && tabManager.isActiveTab()) {
    tabManagerChannel.broadcast(name, data);
  }
};

const { app, router } = createApp(store);

router.onReady(() => {
  app.$mount('#app');
});

// service worker
// if (location.protocol === 'https:' && navigator.serviceWorker) {
//   navigator.serviceWorker.register('/service-worker.js');
// }
